export interface SatNoteCopy {
  body: string[];
  button: string;
}

export const COPY: SatNoteCopy = {
  body: [
    'By signing this satisfaction note, you confirm that the goods/services have been delivered/installed satisfactorily and in line with the terms of your contract.',
    'You acknowledge that it is your responsibility to register or do anything that the retailer may require in order to register the relevant product warranties and recognize that failure to do so invalidates any protection you receive from such warranties.',
  ],
  button: 'I agree that I have received the goods/services satisfactorily.',
};
